import { ResearchFilter, BacteriaResearchSummary } from '@snapi/types';
import { useToggle } from 'react-use';
import { useState } from 'react';
import { Percentage, Subtitle } from '@snapi/luxury';
import { BacteriaResearchSummaryCardPdf } from '../bacteria-research-summary-card';
import { useReportContext } from '../report-context';

interface ReportBacteriaListPdfProps {
  summary: BacteriaResearchSummary[];
  other: number;
}

export const ReportBacteriaListPdf: React.FC<ReportBacteriaListPdfProps> = ({
  summary,
  other,
}) => {
  const [filter, setFilter] = useState<ResearchFilter>({
    categories: [],
    conditions: [],
  });

  const [selected, setSelected] = useState<null | string>(null);

  const handleSelect = (name: string) => () => {
    if (selected === name) {
      setSelected(null);
    } else {
      setSelected(name);
    }
  };

  return (
    <section className="flex flex-col items-center pb-0 bg-blue-light">
      <div className="flex flex-col gap-3 container mb-10 text-blue-dark">
        <h2 className="flex ">Raw Data</h2>
        <p className="flex ">
          The bacteria guide is where you can learn detailed information
          regarding your baby’s microbiome test. Try sorting by disruptive
          bacteria to see which bacteria you want to consider decreasing.
          Worried about eczema? Check out the eczema association to learn more
          about the bacteria related to this condition.
        </p>
      </div>

      <div className="container flex flex-col gap-10 ">
        <div className="flex flex-1 flex-col ">
          <div className="flex flex-[2] flex-col justify-center">
            <div className="flex flex-1 pb-2 mb-5 border-b border-blue-dark justify-center ">
              <div className="flex flex-1">
                <div className="flex flex-1 items-center relative text-blue-dark">
                  <Subtitle>Bacteria name</Subtitle>
                </div>
                <div className="flex flex-1 items-center relative text-blue-dark ml-[110px]">
                  <Subtitle>
                    <span className="flex">Percentage (%)</span>
                  </Subtitle>
                </div>
              </div>
            </div>
            <div className="flex flex-1 justify-center">
              <div className="flex flex-1 flex-col  gap-2">
                {summary.map((summary) => (
                  <div>
                    <BacteriaResearchSummaryCardPdf
                      bacteria={summary.bacteria}
                      species={summary.species}
                      filter={filter}
                      expanded={selected === summary.bacteria.research.name}
                      onExpand={handleSelect(summary.bacteria.research.name)}
                    />
                  </div>
                ))}
                <div className="flex bg-white rounded-xl pb-4 px-3 mb-[75px]">
                  <h5 className="opacity-50">Other</h5>
                  <h5 className="opacity-50 ml-[334px]">
                    {' '}
                    <Percentage percentage={other} />
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
